import { render, staticRenderFns } from "./translation-memory.vue?vue&type=template&id=dc000dc0&"
import script from "./translation-memory.vue?vue&type=script&lang=js&"
export * from "./translation-memory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports